/**
 * @fileoverview gRPC-Web generated client stub for deal_status_comment
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.4.2
// 	protoc              v3.21.12
// source: protobuf/deal_status_comment/deal_status_comment.proto


/* eslint-disable */
// @ts-nocheck


import * as grpcWeb from 'grpc-web';

import * as protobuf_deal_status_comment_deal_status_comment_pb from '../../protobuf/deal_status_comment/deal_status_comment_pb';
import * as protobuf_model_merged_pb from '../../protobuf/model/merged_pb';


export class DealStatusCommentServiceClient {
  client_: grpcWeb.AbstractClientBase;
  hostname_: string;
  credentials_: null | { [index: string]: string; };
  options_: null | { [index: string]: any; };

  constructor (hostname: string,
               credentials?: null | { [index: string]: string; },
               options?: null | { [index: string]: any; }) {
    if (!options) options = {};
    if (!credentials) credentials = {};
    options['format'] = 'binary';

    this.client_ = new grpcWeb.GrpcWebClientBase(options);
    this.hostname_ = hostname.replace(/\/+$/, '');
    this.credentials_ = credentials;
    this.options_ = options;
  }

  methodDescriptorCreate = new grpcWeb.MethodDescriptor(
    '/deal_status_comment.DealStatusCommentService/Create',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_status_comment_deal_status_comment_pb.CreateDealStatusCommentRequest,
    protobuf_model_merged_pb.DealStatusCommentResponse,
    (request: protobuf_deal_status_comment_deal_status_comment_pb.CreateDealStatusCommentRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.DealStatusCommentResponse.deserializeBinary
  );

  create(
    request: protobuf_deal_status_comment_deal_status_comment_pb.CreateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.DealStatusCommentResponse>;

  create(
    request: protobuf_deal_status_comment_deal_status_comment_pb.CreateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealStatusCommentResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.DealStatusCommentResponse>;

  create(
    request: protobuf_deal_status_comment_deal_status_comment_pb.CreateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealStatusCommentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_status_comment.DealStatusCommentService/Create',
        request,
        metadata || {},
        this.methodDescriptorCreate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_status_comment.DealStatusCommentService/Create',
    request,
    metadata || {},
    this.methodDescriptorCreate);
  }

  methodDescriptorUpdate = new grpcWeb.MethodDescriptor(
    '/deal_status_comment.DealStatusCommentService/Update',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_status_comment_deal_status_comment_pb.UpdateDealStatusCommentRequest,
    protobuf_model_merged_pb.DealStatusCommentResponse,
    (request: protobuf_deal_status_comment_deal_status_comment_pb.UpdateDealStatusCommentRequest) => {
      return request.serializeBinary();
    },
    protobuf_model_merged_pb.DealStatusCommentResponse.deserializeBinary
  );

  update(
    request: protobuf_deal_status_comment_deal_status_comment_pb.UpdateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_model_merged_pb.DealStatusCommentResponse>;

  update(
    request: protobuf_deal_status_comment_deal_status_comment_pb.UpdateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealStatusCommentResponse) => void): grpcWeb.ClientReadableStream<protobuf_model_merged_pb.DealStatusCommentResponse>;

  update(
    request: protobuf_deal_status_comment_deal_status_comment_pb.UpdateDealStatusCommentRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_model_merged_pb.DealStatusCommentResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_status_comment.DealStatusCommentService/Update',
        request,
        metadata || {},
        this.methodDescriptorUpdate,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_status_comment.DealStatusCommentService/Update',
    request,
    metadata || {},
    this.methodDescriptorUpdate);
  }

  methodDescriptorGet = new grpcWeb.MethodDescriptor(
    '/deal_status_comment.DealStatusCommentService/Get',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsRequest,
    protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse,
    (request: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse.deserializeBinary
  );

  get(
    request: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse>;

  get(
    request: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse>;

  get(
    request: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.GetDealStatusCommentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_status_comment.DealStatusCommentService/Get',
        request,
        metadata || {},
        this.methodDescriptorGet,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_status_comment.DealStatusCommentService/Get',
    request,
    metadata || {},
    this.methodDescriptorGet);
  }

  methodDescriptorDelete = new grpcWeb.MethodDescriptor(
    '/deal_status_comment.DealStatusCommentService/Delete',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsRequest,
    protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse,
    (request: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse.deserializeBinary
  );

  delete(
    request: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse>;

  delete(
    request: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse>;

  delete(
    request: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.DeleteDealStatusCommentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_status_comment.DealStatusCommentService/Delete',
        request,
        metadata || {},
        this.methodDescriptorDelete,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_status_comment.DealStatusCommentService/Delete',
    request,
    metadata || {},
    this.methodDescriptorDelete);
  }

  methodDescriptorList = new grpcWeb.MethodDescriptor(
    '/deal_status_comment.DealStatusCommentService/List',
    grpcWeb.MethodType.UNARY,
    protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsRequest,
    protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse,
    (request: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsRequest) => {
      return request.serializeBinary();
    },
    protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse.deserializeBinary
  );

  list(
    request: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null): Promise<protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse>;

  list(
    request: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse) => void): grpcWeb.ClientReadableStream<protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse>;

  list(
    request: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsRequest,
    metadata: grpcWeb.Metadata | null,
    callback?: (err: grpcWeb.RpcError,
               response: protobuf_deal_status_comment_deal_status_comment_pb.ListDealStatusCommentsResponse) => void) {
    if (callback !== undefined) {
      return this.client_.rpcCall(
        this.hostname_ +
          '/deal_status_comment.DealStatusCommentService/List',
        request,
        metadata || {},
        this.methodDescriptorList,
        callback);
    }
    return this.client_.unaryCall(
    this.hostname_ +
      '/deal_status_comment.DealStatusCommentService/List',
    request,
    metadata || {},
    this.methodDescriptorList);
  }

}

